"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatureAggregate = void 0;
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
function signatureAggregate(aggregate) {
    return (records = [], field) => {
        const logic = (0, fields_logic_registry_1.getFieldLogic)(field.field_type);
        const files = records
            .map((record) => { var _a; return (_a = logic.getFieldValueFromRecord(record, field).drawing) !== null && _a !== void 0 ? _a : []; })
            .flat(1);
        return aggregate(files);
    };
}
exports.signatureAggregate = signatureAggregate;
